module.exports = __webpack_public_path__ + "static/ceplova-e50f9ed1dc344c883f6e827c9b3cd42b.jpg";